import { CreateCheckout } from '~core/payments';
import { onErrorShowMessage } from '~src/errors';

/**
 * Creates a checkout session
 * @param {string} selectedModuleId - Selected module ID
 * @param {Object} user - User info
 * @param {Object} options - Additional options
 * @param {string} [options.paymentMethodType] - Payment method type: 'card' or 'sepa_debit'
 * @returns {Promise<Object|null>} Checkout session or null if creation fails
 */
const createCheckoutSession = async (selectedModuleId, user, options = {}) => {
  try {
    const createCheckout = new CreateCheckout(process.env.USER_API_URL);
    createCheckout
      .withoutRedirect()
      .withRedirectOnCompletion('never')
      .withUIMode('embedded')
      .withModuleId(selectedModuleId)
      .withOrgId(user.org_pointer.objectId);

    // Add payment method type if specified
    if (options.paymentMethodType) {
      createCheckout.withPaymentMethodTypes([options.paymentMethodType]);
    }

    const createCheckoutSessionApiUrl = createCheckout.getUrl();

    // Make a GET request to the checkout session API URL
    const response = await fetch(createCheckoutSessionApiUrl);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching checkout session:', error);
    onErrorShowMessage(false, {
      icon: 'error',
      title: 'Errore',
      text:
        'Si è verificato un errore durante la creazione della sessione di pagamento.',
      confirmButtonColor: '#278e8e',
    });
    return null;
  }
};

export default createCheckoutSession;
